<template>
  <ve-table style="width: 100%;" :scroll-width="scrollWidth" :columns="columns" :table-data="tableData"
    row-key-field-name="keyName" :rowStyleOption="{ stripe: true }" />
</template>
<script>
import { mapGetters } from 'vuex'
import { formatMoney } from '@/util'
import { StatusMap } from '@/constants'

export default {
  props: {
    scrollWidth: {
      type: Number,
      require: true
    },
    keyName: {
      type: String,
      require: true
    },
    tableData: {
      type: Array,
      require: true,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters([
      'achievementRate'
    ]),
    columns() {
      const achievementRate = parseInt(this.achievementRate) || 1
      return [
        {
          field: '',
          key: 'expand',
          title: '',
          width: 30,
          align: 'center',
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.isLeaf ? '' : h('div', {
              style: {
                'font-size': '16px',
                position: 'relative',
                top: '-2px'
              },
              on: {
                click: () => {
                  this.$emit('on-expand', row, rowIndex)
                }
              }
            }, row.isExpand ? '-' : '+')
          }
        },
        {
          title: '姓名',
          key: 'l1UserName',
          tree: true,
          align: 'left',
          fixed: 'left',
          width: 60,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('span', {
              style: {
                position: 'relative',
                left: row.isLeaf ? '10px' : 0
              }
            }, row.cUserName || row.l1UserName || '待修正')
          }
        },
        {
          title: '最终转化率',
          key: 'ultimateConversionRate',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const percent = Number(row.ultimateConversionRate * 100).toFixed(2)
            let color = ''
            if (percent >= 2) {
              color = '#19be6b'
            } else if (percent >= 1) {
              color = '#f90'
            } else {
              color = '#ed4014'
            }

            return h('div', {
              style: {
                color
              }
            }, [
              h('span', `${percent}%`)
            ])
          }
        },
        {
          title: '回款金额(元)',
          key: 'commissionAmountTotal',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.commissionAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '通话次数',
          key: 'callCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.callCnt * achievementRate}`)
          }
        },
        {
          title: '接通次数',
          key: 'connCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.connCnt * achievementRate}`)
          }
        },
        {
          title: '新名单',
          key: 'newCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.newCnt * achievementRate}`)
          }
        },
        {
          title: StatusMap['wait-visit'],
          key: 'waitVisitCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.waitVisitCnt * achievementRate}`)
          }
        },
        {
          title: StatusMap['visited'],
          key: 'visitedCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.visitedCnt * achievementRate}`)
          }
        },
        {
          title: `有方案/方案量`,
          key: 'hasSchemeCnt',
          width: 100,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.hasSchemeCnt * achievementRate} / ${row.solutionCnt * achievementRate}`)
          }
        },
        {
          title: '审批中',
          key: 'reviewingCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.reviewingCnt * achievementRate}`)
          }
        },
        {
          title: '通过',
          key: 'approvedCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.approvedCnt * achievementRate}`)
          }
        },
        {
          title: '放款',
          key: 'issuedCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.issuedCnt * achievementRate}`)
          }
        },
        {
          title: '回款',
          key: 'commissionCnt',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${row.commissionCnt * achievementRate}`)
          }
        },
        {
          title: '批复金额(元)',
          key: 'approvedAmountTotal',
          width: 90,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.approvedAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '放款金额(元)',
          key: 'issuedAmountTotal',
          width: 90,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.issuedAmountTotal * achievementRate).toFixed(0)))
          }
        },
        {
          title: '待放金额(元)',
          key: 'waitIssuedAmountTotal',
          width: 90,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number((row.approvedAmountTotal - row.issuedAmountTotal) * achievementRate).toFixed(0)))
          }
        },
        {
          title: `上门率`,
          key: 'visitedRate',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.visitedRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '接通率',
          key: 'connRate',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.connRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '意向转化率',
          key: 'intentCVRRate',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.intentCVRRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '方案率',
          key: 'hasSchemeRate',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.hasSchemeRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '进件率',
          key: 'reviewingRate',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.reviewingRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '批复率',
          key: 'approvedRate',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.approvedRate * 100).toFixed(2)}%`)
          }
        },
        {
          title: '件均(元)',
          key: 'issuedAmountAvg',
          width: 60,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', formatMoney(Number(row.issuedAmountAvg).toFixed(0)))
          }
        },
        {
          title: '实际点位',
          key: 'commissionPoint',
          width: 80,
          align: 'center',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', `${Number(row.commissionPoint * 100).toFixed(2)}%`)
          }
        }
      ]
    }
  }
}
</script>
